// This file was auto-generated using scripts/generate-icons.js

/**
 * Icon generated from leave.svg
 *
 * @param {import('preact').JSX.SVGAttributes<SVGSVGElement>} props
 */
export default function LeaveIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      aria-hidden="true"
      {...props}
    >
      <path
        fill="currentColor"
        d="M8 0c4.052 0 8 3.948 8 8s-3.948 8-8 8-8-3.948-8-8 3.948-8 8-8Zm0 2C5.052 2 2 5.052 2 8s3.052 6 6 6 6-3.052 6-6-3.052-6-6-6Zm2.786 4.62-.079.087L9.415 8l1.292 1.293a1 1 0 0 1-1.32 1.497l-.094-.083L8 9.415l-1.293 1.292c-.914.914-2.272-.388-1.493-1.327l.079-.087L6.585 8 5.293 6.707a1 1 0 0 1 1.32-1.497l.094.083L8 6.585l1.293-1.292c.914-.914 2.272.388 1.493 1.327Z"
      />
    </svg>
  );
}
